import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CSubheader,
  CBreadcrumbRouter,
  CRow,
  CCol
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import logo from '../assets/stephen-taylor-data-logo-main.svg'
import SearchFederalPolls from '../views/political/canada/federal/SearchFederalPolls'
import SearchProvincialPolls from '../views/political/canada/provincial/SearchProvincialPolls'
import ReactGA from 'react-ga';
import { useLocation } from 'react-router';
import { SET_DARK_MODE, SET_ASIDE_SHOW, SET_SIDEBAR_SHOW } from '../redux/actions';

// routes config
import { getRoutes } from '../routes'

import { 
  TheHeaderDropdown,
}  from './index'

const TheHeader = (props) => {
  
  const dispatch = useDispatch()
  const asideShow = useSelector(state => state.starter.asideShow)
  const darkMode = useSelector(state => state.starter.darkMode)
  const sidebarShow = useSelector(state => state.starter.sidebarShow)

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({type: SET_SIDEBAR_SHOW, sidebarShow: val})
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({type: SET_SIDEBAR_SHOW, sidebarShow: val})
  }

  var urlpath;
  var provurltest = useLocation().pathname.match(/political\/canada\/provincial\/election\/(.+?)\//);
  var provurltest1 = useLocation().pathname.match(/political\/canada\/provincial\/elections\/([^/]+)\/?$/);
  if (provurltest != null) {
    urlpath = provurltest[1];
  } else {
    if (provurltest1 != null ) {
      console.log(provurltest1);
      urlpath = provurltest1[1];
    } else {
      urlpath = '';
    }
  }
  var fullPath = useLocation().pathname;

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        <img src={logo} height={42} alt="Stephen Taylor Data" />
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CBreadcrumbRouter className="border-0 c-subheader-nav m-0 px-0 px-md-3" routes={getRoutes(urlpath)} />
      </CHeaderNav>

      <CHeaderNav className="px-3">
        <CToggler
          inHeader
          className="ml-3 d-md-down-none"
          onClick={() => { 
            ReactGA.event({ category: "Darkmode", action: "click", label: !darkMode }); 
            //dispatch({type: 'set', darkMode: !darkMode});
            dispatch({type: SET_DARK_MODE, darkMode: !darkMode});
          }}
          title="Toggle Light/Dark Mode"
        >
          <CIcon name="cil-moon" className="c-d-dark-none" alt="CoreUI Icons Moon" />
          <CIcon name="cil-sun" className="c-d-default-none" alt="CoreUI Icons Sun" />
        </CToggler>
        <div className="d-md-down-none mfe-2 c-subheader-nav">
          {(fullPath.match(/\/political\/canada\/federal\/election\/\d{4}\/.*/) || fullPath.match(/\/political\/canada\/provincial\/election\/.+?\/\d{4}\/.*/)) ? 
          <CToggler
            className="btn btn-info d-md-down-none"
            onClick={() => dispatch({type: SET_ASIDE_SHOW, asideShow: !asideShow}) }
          ><span role="img" aria-label="See">✨</span>&nbsp;Related content
          </CToggler> : <></> }
        </div>        
        {/* <TheHeaderDropdownNotif/>
        <TheHeaderDropdownTasks/>
        <TheHeaderDropdownMssg/> */}
        <TheHeaderDropdown/>
      </CHeaderNav>

      {fullPath.match(/\/political\/canada\/federal\/election.*/) ? 
        <CSubheader>
          <CRow className="c-subheader px-3 justify-content-between">
            <CCol xs="12" sm="12" md="12">
              <SearchFederalPolls />
            </CCol>
          </CRow>
        </CSubheader>
      : fullPath.match(/\/political\/canada\/provincial\/election.*/) ? 
        <CSubheader>
          <CRow className="c-subheader px-3 justify-content-between">
            <CCol xs="12" sm="12" md="12">
              <SearchProvincialPolls minj={urlpath} />
            </CCol>
          </CRow>
        </CSubheader>    
      : <></> }
    </CHeader>
  )
}

export default TheHeader
